
import { DiscussionCommentsAndFilesEndPointLogic } from "../../../logic/GeneralDiscussion/DiscussionCommentsAndFilesEndPointLogic";
import { DiscussionLogic } from "./types";
import { generalHandlers } from "./generalHandlers";

export const forecasterHandlers: DiscussionLogic = {
  ...generalHandlers,

  fetchComments: (token, object_type, sharedUid, setComments, last_time?) =>
    DiscussionCommentsAndFilesEndPointLogic.getListOfCommentsPost(
      token,
      object_type,
      sharedUid,
      setComments,
      last_time
    ),

  fetchFiles: (token, object_type, sharedUid, setfiles) =>
    DiscussionCommentsAndFilesEndPointLogic.getListOfFilesPost(
      token,
      object_type,
      sharedUid,
      setfiles
    ),
};
